module.exports = __webpack_public_path__ + "img/Skirt-Front-B3-Db-Ga-Ha-Ia.d60bc7ac.png";